class AddEventTarget {
  addEvent (selector, typeEvent, func) {
    selector.addEventListener(typeEvent, func)
  }
}

export default AddEventTarget
